import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";

const Home = lazy(() => import("./Pages/Sections/Home"));
const Projects = lazy(() => import("./Pages/Sections/Projects"));
const Contact = lazy(() => import("./Pages/Sections/Contact"));

function App() {
  return (
    <BrowserRouter>
      <Header />

      <Suspense fallback={<div className="loading">Loading...</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Suspense>

      <Footer />
    </BrowserRouter>
  );
}

export default App;